"use client";

import { useAuthStore } from "@/store/zustand/useAuthStore";
import { useTranslations } from "next-intl";
import { useParams } from "next/navigation";
import { LegalFooter } from "@/components/legal-footer";

const AuthLayout = ({ children }: { children: React.ReactNode }) => {
  const hasHydrated = useAuthStore((state) => state.hasHydrated);
  const t = useTranslations();
  const params = useParams();
  const locale = params.locale as string;

  if (!hasHydrated) {
    return (
      <div className="flex justify-center items-center px-6 min-h-screen">
        <div className="glass-panel rounded-3xl border border-white/60 px-6 py-4 animate-pulse">
          {t("common.loading")}
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen flex-col">
      <main className="flex-1">{children}</main>
      <LegalFooter locale={locale} />
    </div>
  );
};

export default AuthLayout;
